<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
<div class="v4-p-table my-5">
  <div [hidden]="skelition || !permissionTemplate" class="w-100">
    <div class="my-4">
      <label style="font-weight: 600; margin-bottom: 0.3rem; color: white">{{
        "Validity label" | translator
        }}</label>
      <input class="ms-bgg" [(ngModel)]="permissionName" class="w-100" type="text" pInputText
        placeholder="{{ 'Validity label' | translator }}" />
    </div>
    <div class="d-flex mb-2 justify-content-between">
      <div class="d-flex gap-3">
        <div class="d-flex gap-2 align-items-center">
          <span class="v4-color-white">{{ "Sub interface" | translator }}</span>
          <div style="
              width: 20px;
              height: 20px;
              background-color: rgba(255, 255, 255, 0.3);
            "></div>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <span class="v4-color-white">{{
            "Basic interface" | translator
            }}</span>
          <div style="
              width: 20px;
              height: 20px;
              background-color: rgba(34, 33, 54, 0.5);
              color: white;
            "></div>
        </div>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <span class="v4-color-white">{{ "select all" | translator }}</span>
        <p-checkbox [(ngModel)]="selectAll" (ngModelChange)="handleMarkAll($event)" [binary]="true"></p-checkbox>
      </div>
    </div>

    <p-table [columns]="cols" [value]="permissionTemplate" [hidden]="permissionTemplate == null">
      <ng-template class="my-3" pTemplate="header" let-columns>
        <tr [ngClass]="{ 'sticky-content': isScrolled }">
          <th [ngStyle]="colIndex == 0 ? { width: '20%' } : { width: '10%' }"
            *ngFor="let col of columns; let colIndex = index">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-p>
        <tr style="background-color: rgba(34, 33, 54, 0.5); color: white">
          <td [ngStyle]="{ width: '20%' }">{{ p.arabic }}</td>
          <td [ngStyle]="{ width: '10%' }">
            <p-treeSelect appendTo="body" [hidden]="!p.ouRequired || skelition" class="w-md-20rem w-100"
              containerStyleClass="w-100" style="color: black" [(ngModel)]="p.ou" [options]="treeData"
              placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true" (onNodeSelect)="p.ou = $event.node">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label || node.name }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-multiSelect class="v4-multi" appendTo="body" placeholder="{{ 'Select a tag' | translator }}"
              [hidden]="!p.tagRequired || skelition" [options]="tags[p.tagAlias]" [(ngModel)]="p.tag"
              optionLabel="label" optionValue="value"></p-multiSelect>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="p.options.options.read" [hidden]="!p.options.options.hasOwnProperty('read')"
              [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="p.options.options.write" [hidden]="!p.options.options.hasOwnProperty('write')"
              [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="p.options.options.update" [hidden]="!p.options.options.hasOwnProperty('update')"
              [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="p.options.options.delete" [hidden]="!p.options.options.hasOwnProperty('delete')"
              [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-radioButton *ngIf="p.options.type == 'RADIO'" [(ngModel)]="p.options.options.allow"
              [value]="true"></p-radioButton>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-radioButton *ngIf="p.options.type == 'RADIO'" [(ngModel)]="p.options.options.allow"
              [value]="false"></p-radioButton>
          </td>
        </tr>
        <!-- Children rendering -->
        <tr style="background-color: rgba(255, 255, 255, 0.3); color: white" [hidden]="!p.children"
          *ngFor="let child of p.children">
          <td [ngStyle]="{ width: '20%' }">{{ child.arabic }}</td>
          <td [ngStyle]="{ width: '10%' }">
            {{child.ou}}
            <p-treeSelect appendTo="body" *ngIf="child.ouRequired && !!child.ou" class="w-md-20rem w-100"
              containerStyleClass="w-100" style="color: black" [(ngModel)]="child.ou" [options]="treeData"
              placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label || node.name }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <div style="max-width: 100%; box-sizing: border-box; height: 50px">
              <p-multiSelect class="v4-multi" appendTo="body" placeholder="{{ 'Select a tag' | translator }}"
                [hidden]="!child.tagRequired || skelition" [options]="tags[child.tagAlias]" [(ngModel)]="child.tag"
                optionLabel="label" optionValue="value"></p-multiSelect>
            </div>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="child.options.options.read"
              [hidden]="!child.options.options.hasOwnProperty('read')" [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="child.options.options.write"
              [hidden]="!child.options.options.hasOwnProperty('write')" [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="child.options.options.update"
              [hidden]="!child.options.options.hasOwnProperty('update')" [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-checkbox [(ngModel)]="child.options.options.delete"
              [hidden]="!child.options.options.hasOwnProperty('delete')" [binary]="true" inputId="binary"></p-checkbox>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-radioButton *ngIf="child.options.type == 'RADIO'" [(ngModel)]="child.options.options.allow"
              [value]="true"></p-radioButton>
          </td>
          <td [ngStyle]="{ width: '10%' }">
            <p-radioButton *ngIf="child.options.type == 'RADIO'" [(ngModel)]="child.options.options.allow"
              [value]="false"></p-radioButton>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="isUpdate" class="d-flex gap-2 align-items-center mt-3">
      <span>{{ "the condition" | translator }}</span>
      <p-checkbox [(ngModel)]="updateActive" [binary]="true"></p-checkbox>
    </div>
    <div class="my-4">
      <button (click)="submitForm()" class="v4-btn-every w-100">
        {{ "OK" | translator }}
      </button>
    </div>
  </div>
</div>
<p-messages [(value)]="messages" [enableService]="true"></p-messages>
<app-footer></app-footer>